export default __webpack_public_path__ + "images/f6e4df86ba3af338fc63847495197841.svg";